import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PromoStatusService } from '../../services/promo-status.service';
import { CrustLogoComponent } from '../../shared/svg/crust-logo';

@Component({
	selector: 'app-promo-not-active',
	imports: [CrustLogoComponent],
	templateUrl: './promo-not-active.html',
	styleUrl: './promo-not-active.scss'
})
export class PromoNotActiveComponent implements OnInit {
	public promoStatusService = inject(PromoStatusService);
	private router = inject(Router);

	// Expose service signals to template
	promoConfig = this.promoStatusService.promoConfig;
	isLoading = this.promoStatusService.isLoading;
	error = this.promoStatusService.error;

	ngOnInit(): void {
		// Check if promo is active and redirect to home if it is
		if (this.promoStatusService.isPromoActive()) {
			this.router.navigate(['/']);
		}
	}

	/**
	 * Get formatted date range for display
	 */
	getFormattedDateRange(): string | null {
		return this.promoStatusService.getFormattedDateRange();
	}

	/**
	 * Get the reason why promotion is not active
	 */
	getInactiveReason(): string {
		const config = this.promoConfig();
		if (!config) {
			return 'Promotion configuration not available';
		}

		if (!config.isLive) {
			return 'This promotion is currently not live';
		}

		const today = new Date();
		const startDate = new Date(config.management.promoStartDate);
		const endDate = new Date(config.management.promoEndDate);

		if (today < startDate) {
			return `This promotion starts on ${startDate.toLocaleDateString('en-AU')}`;
		}

		if (today > endDate) {
			return `This promotion ended on ${endDate.toLocaleDateString('en-AU')}`;
		}

		return 'This promotion is not currently active';
	}
}